"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["inProcess", "onClick"];

function IconProfile(_ref) {
  var inProcess = _ref.inProcess,
      onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var iconClassName = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-user');
  }, []);

  function handleClick(event) {
    onClick(event);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper'],
    "data-locator": props['data-locator'],
    onClick: function onClick(event) {
      return handleClick(event);
    }
  }, inProcess ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['spinner'],
    "data-locator": props['data-locator'] + '.process'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['animation']
  })) : /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClassName,
    "data-locator": props['data-locator'] + '.icon'
  }));
}

var _default = /*#__PURE__*/_react["default"].memo(IconProfile);

exports["default"] = _default;